import { render } from "./addEdit.vue?vue&type=template&id=182ff4fb"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/examSchedule/addEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "182ff4fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('182ff4fb', __exports__)) {
    console.log('reload')
    api.reload('182ff4fb', __exports__)
  }
  
  module.hot.accept("./addEdit.vue?vue&type=template&id=182ff4fb", () => {
    console.log('re-render')
    api.rerender('182ff4fb', render)
  })

}


export default __exports__